import React from 'react'
import { SaveButton, Toolbar } from 'react-admin'

export const DefaultToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="show"
            submitOnEnter={true}
        />
    </Toolbar>
);